import { XCircle } from "lucide-react";
import { McpConsentFlow } from "./providers/mcp-provider";
import { DiscordLinkFlow } from "./providers/discord-provider";

export function OAuthConsentPage() {
  const params = new URLSearchParams(window.location.search);
  const provider = params.get("provider");

  if (provider === "discord") {
    return <DiscordLinkFlow />;
  }

  if (!provider || provider === "mcp") {
    return <McpConsentFlow />;
  }

  return (
    <div className="rounded-2xl border border-stroke-subtle bg-surface-raised p-8 text-center">
      <XCircle className="mx-auto mb-3 size-10 text-signal-danger" />
      <h2 className="text-lg font-bold">알 수 없는 provider</h2>
      <p className="mt-2 text-[13px] text-text-tertiary">
        provider="{provider}"은(는) 지원되지 않습니다.
      </p>
    </div>
  );
}
